import React from 'react';
import './thankyou.scss';

const ThankYouPage = () => (
  <React.Fragment>
    <h2 className={'content-block'}>Thankyou</h2>
    <div className={'content-block'}>
      <div className={'dx-card responsive-paddings'}>
        <p>Your form has been successfully submitted!</p>
      </div>
    </div>
  </React.Fragment>
);

export default ThankYouPage;